import type { PlayerProfile, BonusOffer, JackpotCampaign, Reward } from '../../types/features';

class PlayerService {
    private static instance: PlayerService;
    private profile: PlayerProfile = {
        id: 'PLR-2024-0392847',
        nickname: 'CoolPlayer123',
        level: 5,
        xp: 2750,
        xpRequired: 5000,
        gameCoins: 5000,
        statistics: {
            totalSpins: 1234,
            biggestWin: 750,
            winRate: 32,
            totalWinnings: 12500
        }
    };

    private constructor() { }

    static getInstance(): PlayerService {
        if (!PlayerService.instance) {
            PlayerService.instance = new PlayerService();
        }
        return PlayerService.instance;
    }

    getProfile(): PlayerProfile {
        return { ...this.profile };
    }

    updateNickname(nickname: string): void {
        this.profile.nickname = nickname;
    }

    addXP(amount: number): void {
        this.profile.xp += amount;
        if (this.profile.xp >= this.profile.xpRequired) {
            this.levelUp();
        }
    }

    private levelUp(): void {
        this.profile.level += 1;
        this.profile.xp = this.profile.xp - this.profile.xpRequired;
        this.profile.xpRequired = Math.floor(this.profile.xpRequired * 1.5);
    }

    addGameCoins(amount: number): void {
        this.profile.gameCoins += amount;
    }

    updateStatistics(spins: number, win: number): void {
        this.profile.statistics.totalSpins += spins;
        if (win > 0) {
            this.profile.statistics.totalWinnings += win;
            if (win > this.profile.statistics.biggestWin) {
                this.profile.statistics.biggestWin = win;
            }
        }
        this.profile.statistics.winRate =
            (this.profile.statistics.totalWinnings / this.profile.statistics.totalSpins) * 100;
    }
}

export const playerService = PlayerService.getInstance(); 